// extracted by mini-css-extract-plugin
export default {"skillCard":"view-role-skills_skillCard__uNQAe","skillCardText":"view-role-skills_skillCardText__93ocK"};